import React, { useMemo, useState, useEffect, useRef } from "react";
import { useCities, useStates } from "../../APIs/MasterAPIHelper";
import {
  GetAllZSectionforWeb,
  GetAllSZTypeforWeb,
} from "../../APIs/APIHelperforWeb";
import {
  ZSections,
  SZType,
  StateURL,
  CityURL,
  AreaURL,
  Property,
  FurnishingMasterURL,
} from "../../APIs/APIUrls";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./AddProperty2.css";
import "./AddPropertyPrice.css";
import "./AddPGDetails.css";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Title } from "chart.js";
import { NewProperty } from "../../APIs/APIUrls";
import Pagination2 from "../common/Pagination2.jsx";
import { Link } from "react-router-dom";
import { isArray } from "chart.js/helpers";

const PROPERTY_FOR_OPTIONS = ["Sell", "Rent", "PG"];

const BUILDING_TYPE_OPTIONS = ["Residential", "Commercial"];

const PROPERTY_TYPE_OPTIONS = {
  Residential: [
    "Flats / Apartments",
    "Independent House",
    "Builder Floor",
    "Studio Apartments",
    "Villa",
  ],
  Commercial: [
    "Commercial Shops",
    "Showrooms",
    "Office Space",
    "Business Center",
    "Farm / Agricultural Land",
    "Commercial Plots",
    "Industrial Land",
    "Guest House",
    "Hotel & Restaurant",
    "Warehouse / Godown",
    "Factory",
  ],
  PG: [
    "Flats / Apartments",
    "Independent House",
    "Builder Floor",
    "Studio Apartments",
    "Villa",
  ],
};

const AREA_UNITS = ["Sq.Ft.", "Sq.Yd.", "Sq.Mt.", "Acre"];
const RENT_AVAILABILITY_OPTIONS = [
  "Immediate",
  "Within 1 Month",
  "Within 3 Months",
  "Under Notice",
];
const SELL_AVAILABILITY_OPTIONS = [
  "Ready to Move",
  "Under Construction",
  "New Launch",
];
const POSSESSION_BY_OPTIONS = [
  "Expected by",
  "Within 3 Months",
  "Within 6 Months",
  "By 2026",
  "By 2027",
  "By 2028",
  "By 2029",
  "By 2030",
];
const FURNISHING_OPTIONS = ["Furnished", "Semi-Furnished", "Unfurnished"];
const OWNERSHIP_OPTIONS = ["Freehold", "Leasehold", "Co-operative Society"];
const AVAILABLE_FOR_OPTIONS = [
  "All",
  "Family",
  "Boys Only",
  "Girls Only",
  "Couples",
];
const PARKING_OPTIONS = ["Public", "Private", "No Parking"];
const FLOOR_OPTIONS = [
  "Basement",
  "Ground",
  "1st",
  "2nd",
  "3rd",
  "4th",
  "5th",
  "More",
];
const ROOM_OPTIONS = ["1", "2", "3", "4", "5", "6", "More"];
const WASHROOM_OPTIONS = ["1", "2", "3", "4", "5", "6", "More"];
const FLOOR_MORE_OPTIONS = ["More"];
const ROOM_MORE_OPTIONS = ["More"];
const WASHROOM_MORE_OPTIONS = ["More"];
const ROOM_TYPE_OPTIONS = [
  "Private",
  "Twin Sharing",
  "Triple Sharing",
  "Quad Sharing",
];
const FOOD_MEALS_OPTIONS = ["With Meals", "Without Meals"];
const SUITABLE_FOR_OPTIONS = ["Students", "Working Professionals", "Both"];
const PG_AVAILABLE_FOR_OPTIONS = [
  "Girls",
  "Boys",
  "Working Women",
  "Working Mens",
];
const YES_NO_OPTIONS = [
  { TypeId: "Yes", TypeName: "Yes" },
  { TypeId: "No", TypeName: "No" },
];
const NOTICE_PERIOD_OPTIONS = ["15 Days", "30 Days", "45 Days"];
const PG_RULES_OPTIONS = [
  "No Smoking",
  "No Guardians Stay",
  "No Drinking",
  "No Non-Veg",
  "Visiter Allow",
  "Party",
  "Loud music",
  "Opposite Gender",
];

const FURNISHING_DETAIL_FALLBACK_OPTIONS = [
  "Water Purifier",
  "Fan",
  "Fridge",
  "Exhaust Fan",
  "Dining Table",
  "Geyser",
  "Stove",
  "Light",
  "Curtains",
  "Modular Kitchen",
  "TV",
  "Chimney",
  "AC",
  "Bed",
  "Wardrobe",
  "Sofa",
  "Washing Machine",
  "Microwave",
];

function renderToggleChipGroup({
  label,
  options,
  value,
  setValue,
  required = false,
  rowClassName = "ap-price-row ap-price-row-top",
  itemref,
}) {
  return (
    <div className={`${rowClassName} ap-pg-row`}>
      <label className="ap-price-label ap-pg-label">
        {label} {required ? <span>*</span> : null}
      </label>
      <div className="ap-price-control ap-price-chip-list ap-pg-chip-list">
        {options.map((option, index) => (
          <button
            key={option.TypeId}
            type="button"
            className={`ap2-chip ${String(value) === String(option.TypeId) ? "is-active" : ""}`}
            onClick={() =>
              setValue((currentValue) =>
                String(currentValue) === String(option.TypeId)
                  ? ""
                  : option.TypeId,
              )
            }
            ref={index === 0 ? itemref : null}
          >
            {option.TypeName}
          </button>
        ))}
      </div>
    </div>
  );
}

function AddProperty2() {
  const tcn = JSON.parse(localStorage.getItem("tcn"));

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const vendorid = localStorage.getItem("id") || 0;

  //pagination and search filter states
  const [page, setPage] = useState(1);
  const [ItemsPerPage, setItemsPerPage] = useState(10);
  const [SearchTerm, setSearchTerm] = useState("");

  const [lstZSections, setLstZSections] = useState([]);
  const [lstSZType, setLstSZType] = useState([]);
  const [lstPropertyTypes, setLstPropertyTypes] = useState([]);
  const [lstState, setLstState] = useState([]);
  const [lstCity, setLstCity] = useState([]);
  const [lstArea, setLstArea] = useState([]);
  const [lstUnitArea, setLstUnitArea] = useState([]);
  const [areaId, setAreaId] = useState("0");
  const [lstPossessionBy, setLstPossessionBy] = useState([]);
  const [lstPropertyOntheFloor, setLstPropertyOntheFloor] = useState([]);
  const [lstNoofRooms, setLstNoofRooms] = useState([]);
  const [lstNoofWashrooms, setLstNoofWashrooms] = useState([]);
  const [lstFurnishStatus, setLstFurnishStatus] = useState([]);
  const [lstFacing, setLstFacing] = useState([]);
  const [lstAgeofProperty, setLstAgeofProperty] = useState([]);
  const [lstOwnershipStatus, setLstOwnershipStatus] = useState([]);
  const [lstAvailableforRent, setLstAvailableforRent] = useState([]);

  const [lstPGRulesAllowed, setLstPGRulesAllowed] = useState([]);
  const [lstPGRulesNotAllowed, setLstPGRulesNotAllowed] = useState([]);
  const [lstParking, setLstParking] = useState([]);
  const [lstPGRoomType, setLstPGRoomType] = useState([]);
  const [lstPGFooDMeal, setLstPGFooDMeal] = useState([]);
  const [lstPGSuitableFor, setLstPGSuitableFor] = useState([]);
  const [lstPGAvailablefor, setLstPGAvailablefor] = useState([]);
  const [lstPGNoticePeriod, setLstPGNNoticePeriod] = useState([]);
  const [lstFurnishingDetails, setLstFurnishingDetails] = useState([]);

  const [myProperties, setMyProperties] = useState([]);
  const [myPropertiesFilter, setMyPropertiesFilter] = useState([]);

  useEffect(() => {
    const fetchZSections = async () => {
      try {
        const response = await fetch(ZSections + "GetAllZSectionsforWeb", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${tcn}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          throw new Error(`ZSections request failed: ${response.status}`);
        }

        const result = await response.json();
        const filterdata = result?.data || [];
        setLstZSections(filterdata.sort((a, b) => a.SectionId - b.SectionId));
      } catch (error) {
        console.error("Error fetching ZSections:", error);
      }
    };

    const fetchSZTypes = async () => {
      try {
        const response = await fetch(SZType + "GetAllSZTypeforWeb", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${tcn}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          throw new Error(`SZType request failed: ${response.status}`);
        }

        const result = await response.json();
        const filterdata = Array.isArray(result?.data)
          ? result.data.filter((item) => item.IsActive == true)
          : [];
        setLstSZType(filterdata);
      } catch (error) {
        console.error("Error fetching SZType:", error);
      }
    };

    const fetchStates = async () => {
      try {
        const response = await fetch(StateURL + "GetAllState", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${tcn}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          throw new Error(`States request failed: ${response.status}`);
        }

        const result = await response.json();
        const filterdata = Array.isArray(result?.data)
          ? result.data.filter((item) => item.IsActive == true)
          : [];
        filterdata.unshift({ StateId: 0, StateName: "Select State" });
        setLstState(filterdata);
      } catch (error) {
        console.error("Error fetching States:", error);
      }
    };

    const fetchFurnishingDetails = async () => {
      try {
        const response = await fetch(FurnishingMasterURL + "GetAllFurnishing", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${tcn}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          throw new Error(`Furnishing request failed: ${response.status}`);
        }

        const result = await response.json();
        const filterdata = Array.isArray(result?.data)
          ? result.data.filter((item) => item.IsActive == true)
          : [];

        setLstFurnishingDetails(filterdata);
      } catch (error) {
        console.error("Error fetching furnishing details:", error);
        setLstFurnishingDetails([]);
      }
    };

    fetchZSections();
    fetchSZTypes();
    fetchStates();
    fetchFurnishingDetails();
    fnGetMyProperties();
  }, []);

  useEffect(() => {
    //Render Property Types based on SectionId 11 : Residential Property Types
    const filteredPropertyTypes = lstSZType.filter(
      (type) => type.SectionId == 11,
    );
    setLstPropertyTypes(filteredPropertyTypes);

    //SectionId 22 - Unit Area
    const unitArea = lstSZType.filter((type) => type.SectionId == "22");
    unitArea.unshift({ TypeId: 0, TypeName: "Select Unit Area" });
    setLstUnitArea(unitArea);

    //SectionId 23 - Possession By Options
    const possessionOptions = lstSZType.filter(
      (type) => type.SectionId == "23",
    );
    //possessionOptions.unshift({ TypeId: 0, TypeName: 'Select Possession By' });
    setLstPossessionBy(possessionOptions);

    //SectionId 24 -Property On the Floor Options
    const propertyOnTheFloorOptions = lstSZType.filter(
      (type) => type.SectionId == "24",
    );
    setLstPropertyOntheFloor(propertyOnTheFloorOptions);

    //SectionId 4 - No of Rooms Options
    const noofRoomsOptions = lstSZType.filter((type) => type.SectionId == "4");
    setLstNoofRooms(noofRoomsOptions);

    //SectionId 5 - No of Wash Rooms Options
    const noofWashRoomsOptions = lstSZType.filter(
      (type) => type.SectionId == "5",
    );
    setLstNoofWashrooms(noofWashRoomsOptions);

    //SectionId 25 - Furnished Status Options
    const furnishedStatusOptions = lstSZType.filter(
      (type) => type.SectionId == "45",
    );
    setLstFurnishStatus(furnishedStatusOptions);

    //SectionId 15 - Facing Options
    const facingOptions = lstSZType.filter((type) => type.SectionId == "15");
    setLstFacing(facingOptions);

    //SectionId 26 - Age of Property Options
    const ageOfPropertyOptions = lstSZType.filter(
      (type) => type.SectionId == "26",
    );
    setLstAgeofProperty(ageOfPropertyOptions);

    //SectionId 27 - Ownership Status Options
    const ownershipStatusOptions = lstSZType.filter(
      (type) => type.SectionId == "27",
    );
    setLstOwnershipStatus(ownershipStatusOptions);

    //SectionId 28 - Available for Rent Options
    const availableForRentOptions = lstSZType.filter(
      (type) => type.SectionId == "28",
    );
    setLstAvailableforRent(availableForRentOptions);

    //SectionId 30 - Available for PG
    const availableForPGOptions = lstSZType.filter(
      (type) => type.SectionId == "30",
    );
    setLstPGAvailablefor(availableForPGOptions);

    //SectionId 31 - PG Rules Allowed
    const pgRulesAllowedOptions = lstSZType.filter(
      (type) => type.SectionId == "31",
    );
    setLstPGRulesAllowed(pgRulesAllowedOptions);

    //SectionId 32 - PG Rules not Allowed
    const pgRulesNotAllowedOptions = lstSZType.filter(
      (type) => type.SectionId == "32",
    );
    setLstPGRulesNotAllowed(pgRulesNotAllowedOptions);

    //SectionId 34 - Parking Options
    const parkingOptions = lstSZType.filter((type) => type.SectionId == "34");
    setLstParking(parkingOptions);

    //SectionId 35 - PG Room Type Options
    const pgRoomTypeOptions = lstSZType.filter(
      (type) => type.SectionId == "35",
    );
    setLstPGRoomType(pgRoomTypeOptions);

    //SectionId 36 - PG Food Meal Options
    const pgFoodMealOptions = lstSZType.filter(
      (type) => type.SectionId == "36",
    );
    setLstPGFooDMeal(pgFoodMealOptions);

    //SectionId 37 - PG Suitable Options
    const pgSuitableOptions = lstSZType.filter(
      (type) => type.SectionId == "37",
    );
    setLstPGSuitableFor(pgSuitableOptions);

    //SectionId 38 - PG Notice Period Options
    const pgNoticePeriodOptions = lstSZType.filter(
      (type) => type.SectionId == "38",
    );
    setLstPGNNoticePeriod(pgNoticePeriodOptions);
  }, [lstSZType]);

  useEffect(() => {
    const toSearchText = (value) => String(value ?? "").toLowerCase();
    const searchLower = toSearchText(SearchTerm).trim();

    if (!searchLower) {
      setMyPropertiesFilter(myProperties);
      return;
    }

    const filtered = myProperties.filter((property) => {
      return (
        toSearchText(property?.PropertyTitle).includes(searchLower) ||
        toSearchText(property?.PropertyGeneratedId).includes(searchLower) ||
        toSearchText(property?.PropertyTypeName).includes(searchLower) ||
        toSearchText(property?.StatusName).includes(searchLower) ||
        toSearchText(property?.PropertyLabelName).includes(searchLower) ||
        toSearchText(property?.City).includes(searchLower) ||
        toSearchText(property?.State).includes(searchLower) ||
        toSearchText(property?.GovtPropertyId).includes(searchLower) ||
        toSearchText(property?.PropertyPrice).includes(searchLower) ||
        toSearchText(property?.FacingDirection).includes(searchLower) ||
        toSearchText(property?.ProjectTypeName).includes(searchLower) ||
        toSearchText(property?.ConstructionStatusName).includes(searchLower)
      );
    });

    setMyPropertiesFilter(filtered);
  }, [SearchTerm, myProperties]);

  const fnGetMyProperties = async () => {
    try {
      debugger;
      const userId = localStorage.getItem("id") || vendorid;
      if (!tcn) {
        enqueueSnackbar("Authentication token not found. Please login again.", {
          variant: "error",
        });
        return;
      }

      const response = await fetch(
        NewProperty + "GetNewPropertyByVendorId/" + userId,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tcn}`,
          },
          body: JSON.stringify({}),
        },
      );
      debugger;
      if (!response.ok) {
        if (response.status === 401) {
          enqueueSnackbar(
            "Unauthorized: Your session has expired. Please login again.",
            { variant: "error" },
          );
          localStorage.clear();
          window.location.href = "/";
        }
        throw new Error(`Server error: ${response.status}`);
      }

      const text = await response.text();
      if (!text || text.trim() === "") {
        throw new Error("Server returned an empty response");
      }

      const result = JSON.parse(text);
      // console.log("My Properties:", result.data);
      const dataArray = Array.isArray(result?.data) ? result.data : [];

      setMyProperties(dataArray);
      setMyPropertiesFilter(dataArray);
    } catch (error) {
      console.error("Error fetching properties:", error);
      enqueueSnackbar("Error fetching properties. Please try again.", {
        variant: "error",
      });
    }
  };

  const HandleRequestPropertyfeature = async (propertyId) => {
    try {
      if (!tcn) {
        enqueueSnackbar("Authentication token not found. Please login again.", {
          variant: "error",
        });
        return;
      }

      let data = { PropertyId: propertyId, IsWantFeatureProperty: true };

      const response = await fetch(
        NewProperty + "RequestFeatureMyNewProperty",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tcn}`,
          },
          body: JSON.stringify(data),
        },
      );

      if (!response.ok) {
        if (response.status === 401) {
          enqueueSnackbar(
            "Unauthorized: Your session has expired. Please login again.",
            { variant: "error" },
          );
          localStorage.clear();
          window.location.href = "/";
        }
        throw new Error(`Server error: ${response.status}`);
      }

      const text = await response.text();
      if (!text || text.trim() === "") {
        throw new Error("Server returned an empty response");
      }
      debugger;
      const result = JSON.parse(text);
      if (result.Message === "Success") {
        enqueueSnackbar("Feature property request submitted successfully!", {
          variant: "success",
        });
        fnGetMyProperties(); // Refresh properties to reflect the change
      } else {
        enqueueSnackbar(
          result.message || "Failed to submit feature property request",
          { variant: "error" },
        );
      }
    } catch (error) {
      console.error("Error requesting feature property:", error);
      enqueueSnackbar("Error requesting feature property. Please try again.", {
        variant: "error",
      });
    }
  };

  const fnDeleteProperty = async (propertyId) => {
    try {
      if (!tcn) {
        enqueueSnackbar("Authentication token not found. Please login again.", {
          variant: "error",
        });
        return;
      }

      const data = { PropertyId: propertyId, Value: "deactivate" };
      const response = await fetch(
        NewProperty + "ActivateDeactivateNewProperty/" + propertyId,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tcn}`,
          },
          body: JSON.stringify(data),
        },
      );

      if (!response.ok) {
        if (response.status === 401) {
          enqueueSnackbar(
            "Unauthorized: Your session has expired. Please login again.",
            { variant: "error" },
          );
          localStorage.clear();
          window.location.href = "/";
        }
        throw new Error(`Server error: ${response.status}`);
      }

      const text = await response.text();
      if (!text || text.trim() === "") {
        throw new Error("Server returned an empty response");
      }

      const result = JSON.parse(text);
      if (result.Message === "Success") {
        enqueueSnackbar("Property deleted successfully!", {
          variant: "success",
        });
        debugger;
        fnGetMyProperties(); // Refresh properties to reflect the change
      } else {
        enqueueSnackbar(result.message || "Failed to delete property", {
          variant: "error",
        });
      }
    } catch (error) {
      console.error("Error deleting property:", error);
      enqueueSnackbar("Error deleting property. Please try again.", {
        variant: "error",
      });
    }
  };

  const getClosedPropertyStatus = (propertyForValue) => {
    if (propertyForValue === "Rent") {
      return "Rented";
    }

    if (propertyForValue === "Sell") {
      return "Sold";
    }

    if (propertyForValue === "PG") {
      return "PG Rented";
    }

    return "";
  };

  const isClosedPropertyStatus = (statusName) => {
    const normalizedStatus = String(statusName ?? "")
      .trim()
      .toLowerCase();
    return ["rented", "sold", "pg rented"].includes(normalizedStatus);
  };

  const fnUpdatePropertyStatus = async (propertyItem) => {
    try {
      if (!tcn) {
        enqueueSnackbar("Authentication token not found. Please login again.", {
          variant: "error",
        });
        return;
      }

      const nextStatus = getClosedPropertyStatus(propertyItem?.PropertyFor);
      if (!nextStatus) {
        enqueueSnackbar("Unable to update property status for this listing.", {
          variant: "warning",
        });
        return;
      }

      const data = {
        PropertyId: propertyItem.PropertyId,
        PropertyFor: propertyItem.PropertyFor,
      };
      const response = await fetch(NewProperty + "NewPropertyStatusUpdate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tcn}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        if (response.status === 401) {
          enqueueSnackbar(
            "Unauthorized: Your session has expired. Please login again.",
            { variant: "error" },
          );
          localStorage.clear();
          window.location.href = "/";
        }
        throw new Error(`Server error: ${response.status}`);
      }

      const text = await response.text();
      if (!text || text.trim() === "") {
        throw new Error("Server returned an empty response");
      }

      const result = JSON.parse(text);
      if (result.Message === "Success") {
        enqueueSnackbar(`Property status updated to ${nextStatus}!`, {
          variant: "success",
        });
        fnGetMyProperties();
      } else {
        enqueueSnackbar(result.message || "Failed to update property status", {
          variant: "error",
        });
      }
    } catch (error) {
      console.error("Error updating property status:", error);
      enqueueSnackbar("Error updating property status. Please try again.", {
        variant: "error",
      });
    }
  };

  const states = useStates();

  const [edit, setEdit] = useState(false);

  const [PropertyId, setPropertyId] = useState(0);
  const [propertyFor, setPropertyFor] = useState("Sell");
  const [buildingType, setBuildingType] = useState("0");
  const [propertyType, setPropertyType] = useState("0");
  const [stateId, setStateId] = useState("0");
  const [cityId, setCityId] = useState("0");
  const [locality, setLocality] = useState("");
  const [societyOrPgName, setSocietyOrPgName] = useState("");
  const [address, setAddress] = useState("");
  const [PropertyTitle, setPropertyTitle] = useState("");
  const [PropertyDescription, setPropertyDescription] = useState("");

  //PG UseStates
  const [roomType, setRoomType] = useState("");
  const [foodMeals, setFoodMeals] = useState("");
  const [suitableFor, setSuitableFor] = useState("");
  const [availableFor, setAvailableFor] = useState("");
  const [foodChargesIncluded, setFoodChargesIncluded] = useState("");
  const [electricityChargesIncluded, setElectricityChargesIncluded] =
    useState("");
  const [noticePeriod, setNoticePeriod] = useState("");
  const [otherNoticePeriod, setOtherNoticePeriod] = useState("");
  const [allowedSelectedRules, setAllowedSelectedRules] = useState([]);
  const [notAllowedSelectedRules, setNotAllowedSelectedRules] = useState([]);

  //Property Price & Availability UseStates
  const [builtUpArea, setBuiltUpArea] = useState("");
  const [builtUpAreaUnit, setBuiltUpAreaUnit] = useState("0");

  const [showBuiltUpArea, setShowBuiltUpArea] = useState(false);
  const [builtUpMeasure, setBuiltUpMeasure] = useState("");
  const [builtUpMeasureUnit, setBuiltUpMeasureUnit] = useState("0");

  const [showCarpetArea, setShowCarpetArea] = useState(false);
  const [carpetArea, setCarpetArea] = useState("");
  const [carpetAreaUnit, setCarpetAreaUnit] = useState("0");

  const [showSuperArea, setShowSuperArea] = useState(false);
  const [superArea, setSuperArea] = useState("");
  const [superAreaUnit, setSuperAreaUnit] = useState("0");

  const [price, setPrice] = useState("");
  const [PricePerAreaUnit, setPricePerAreaUnit] = useState("0");

  const [maintenanceCharges, setMaintenanceCharges] = useState("");
  const [securityDeposit, setSecurityDeposit] = useState("");
  const [bookingAmount, setBookingAmount] = useState("");
  const [possessionBy, setPossessionBy] = useState("");
  const [furnishingStatus, setFurnishingStatus] = useState("");
  const [furnishingDetails, setFurnishingDetails] = useState([]);
  const [ownershipStatus, setOwnershipStatus] = useState("");
  const [availableForRent, setAvailableForRent] = useState("");
  const [parking, setParking] = useState("");
  const [propertyOnFloor, setPropertyOnFloor] = useState("");
  const [numberOfRooms, setNumberOfRooms] = useState("");
  const [washroomCount, setWashroomCount] = useState("");
  const [facing, setFacing] = useState("");
  const [ageOfProperty, setAgeOfProperty] = useState("");

  useEffect(() => {
    if (!edit && String(furnishingStatus ?? "").trim() !== "") {
      setFurnishingDetails([]);
    }
  }, [furnishingStatus, edit]);

  const propertyForRef = useRef("Sell");
  const buildingTypeRef = useRef("0");
  const propertyTypeRef = useRef("0");
  const stateIdRef = useRef("0");
  const cityIdRef = useRef("0");
  const localityRef = useRef("");
  const areaRef = useRef("0");
  const societyOrPgNameRef = useRef("");
  const addressRef = useRef("");
  const propertyTitleRef = useRef("");
  const propertyDescriptionRef = useRef("");

  // PG refs
  const roomTypeRef = useRef("");
  const foodMealsRef = useRef("");
  const suitableForRef = useRef("");
  const availableForRef = useRef("");
  const foodChargesIncludedRef = useRef("");
  const electricityChargesIncludedRef = useRef("");
  const noticePeriodRef = useRef("");
  const otherNoticePeriodRef = useRef("");
  const selectedRulesRef = useRef([]);

  // Property Price & Availability refs
  const builtUpAreaRef = useRef("");
  const builtUpAreaUnitRef = useRef("");
  const showBuiltUpAreaRef = useRef(false);
  const builtUpMeasureRef = useRef("");
  const builtUpMeasureUnitRef = useRef("");
  const showCarpetAreaRef = useRef(false);
  const showSuperAreaRef = useRef(false);
  const carpetAreaRef = useRef("");
  const carpetAreaUnitRef = useRef("");
  const superAreaRef = useRef("");
  const superAreaUnitRef = useRef("");
  const priceRef = useRef("");
  const pricePerAreaUnitRef = useRef("");
  const maintenanceChargesRef = useRef("");
  const securityDepositRef = useRef("");
  const bookingAmountRef = useRef("");
  const possessionByRef = useRef("");
  const furnishingStatusRef = useRef("");
  const furnishingDetailsRef = useRef(null);
  const ownershipStatusRef = useRef("");
  const availableForRentRef = useRef("");
  const parkingRef = useRef("");
  const propertyOnFloorRef = useRef("");
  const numberOfRoomsRef = useRef("");
  const washroomCountRef = useRef("");
  const facingRef = useRef("");
  const ageOfPropertyRef = useRef("");

  const isflag = propertyFor === "Rent" || propertyFor === "PG";

  const toggleRuleAllowed = (rule) => {
    setAllowedSelectedRules((currentRules) => {
      const ruleExists = currentRules.some(
        (item) => item.TypeId === rule.TypeId,
      );
      return ruleExists
        ? currentRules.filter((item) => item.TypeId !== rule.TypeId)
        : [...currentRules, { TypeId: rule.TypeId, PGRuleId: rule.PGRuleId }];
    });
  };

  const toggleRuleNotAllowed = (rule) => {
    setNotAllowedSelectedRules((currentRules) => {
      const ruleExists = currentRules.some(
        (item) => item.TypeId === rule.TypeId,
      );
      return ruleExists
        ? currentRules.filter((item) => item.TypeId !== rule.TypeId)
        : [...currentRules, { TypeId: rule.TypeId, PGRuleId: rule.PGRuleId }];
    });
  };

  const renderAreaField = (
    label,
    value,
    setValue,
    unit,
    setUnit,
    fieldId,
    lstUnitArea,
    onRemove,
    refItemfirst,
    refItemsecond,
  ) => (
    <div className="ap-price-row">
      <label className="ap-price-label" htmlFor={fieldId}>
        {label} <span>*</span>
        <span className="ap-price-help">?</span>
      </label>
      <div className="ap-price-control">
        <div className="ap-price-area-group ap-price-square-group ap-price-area-group-with-close">
          <input
            id={fieldId}
            type="text"
            className="form-control ap-price-input ap-price-rect-input ap-price-square-input"
            placeholder={label}
            value={value}
            onChange={(event) => setValue(event.target.value)}
            ref={refItemfirst}
          />
          <select
            className="form-control ap-price-select ap-price-unit-select ap-price-square-select"
            value={unit}
            onChange={(event) => setUnit(event.target.value)}
            ref={refItemsecond}
          >
            {lstUnitArea.map((areaUnit) => (
              <option key={areaUnit.TypeId} value={areaUnit.TypeId}>
                {areaUnit.TypeName}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="ap-price-close-btn"
            onClick={onRemove}
            aria-label={`Remove ${label}`}
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );

  const renderLimitedChipGroup = (
    label,
    options,
    value,
    setValue,
    moreOptions,
    refItem,
  ) => (
    <div className="ap-price-row ap-price-row-top">
      <label className="ap-price-label">{label}</label>
      <div className="ap-price-control ap-price-chip-select-row">
        <div className="ap-price-chip-list ap-price-chip-list-compact">
          {options.slice(0, 6).map((option) => (
            <button
              key={option.TypeId}
              type="button"
              className={`ap-price-chip ${String(value) === String(option.TypeId) ? "is-active" : ""}`}
              onClick={() => setValue(option.TypeId)}
              ref={refItem}
            >
              {option.TypeName}
            </button>
          ))}
        </div>
        <select
          className="form-control ap-price-select ap-price-chip-dropdown"
          value={value}
          onChange={(event) => setValue(event.target.value)}
        >
          {/* <option value="More">More</option> */}
          {moreOptions.map((option) => (
            <option key={option.TypeId} value={option.TypeId}>
              {option.TypeName}
            </option>
          ))}
        </select>
      </div>
    </div>
  );

  const toggleFurnishingDetail = (itemId) => {
    const id = Number(itemId);
    setFurnishingDetails((current) => {
      const exists = current.some((item) => Number(item.FurnishId) === id);
      return exists
        ? current.filter((item) => Number(item.FurnishId) !== id)
        : [...current, { FurnishId: id, Count: 1 }];
    });
  };

  const updateFurnishingDetailCount = (itemId, count) => {
    const safeCount = Math.max(1, Number(count) || 1);
    setFurnishingDetails((current) =>
      current.map((item) =>
        item.FurnishId === itemId ? { ...item, Count: safeCount } : item,
      ),
    );
  };

  const increaseFurnishingDetailCount = (itemId) => {
    setFurnishingDetails((current) =>
      current.map((item) =>
        item.FurnishId === itemId
          ? { ...item, Count: Math.max(1, Number(item.Count) || 1) + 1 }
          : item,
      ),
    );
  };

  const decreaseFurnishingDetailCount = (itemId) => {
    setFurnishingDetails((current) =>
      current.flatMap((item) => {
        if (item.FurnishId !== itemId) {
          return [item];
        }

        const nextCount = Math.max(1, Number(item.Count) || 1) - 1;
        if (nextCount <= 0) {
          return [];
        }

        return [{ ...item, Count: nextCount }];
      }),
    );
  };

  const renderFurnishingDetailOptions = (furnishingStatus) => {
    const furnishingOptions = lstFurnishingDetails.filter(
      (item) => item.TypeId == furnishingStatus,
    );

    return furnishingStatus == "" ||
      !furnishingStatus ? null : furnishingOptions.length > 0 ? (
      <div className="ap-price-row ap-price-row-top ap2-furnishing-row">
        <label className="ap-price-label">Furnishing Details</label>
        <div className="ap-price-control">
          <div className="ap2-furnishing-grid" ref={furnishingDetailsRef}>
            {furnishingOptions.map((option) => {
              const optionName = option.FurninshName;
              const optionId = option.FurnishId;
              const selectedItem = furnishingDetails.find(
                (item) => item.FurnishId == optionId,
              );
              const isActive = !!selectedItem;

              return (
                <div
                  key={optionId}
                  className={`ap2-furnishing-card ${isActive ? "is-active" : ""}`}
                >
                  <button
                    type="button"
                    className="ap2-furnishing-toggle"
                    onClick={() => toggleFurnishingDetail(optionId)}
                    aria-pressed={isActive}
                  >
                    <span className="ap2-furnishing-title">{optionName}</span>
                    <span className="ap2-furnishing-state">
                      {isActive ? "Added" : "Tap to add"}
                    </span>
                  </button>
                  {isActive ? (
                    <div
                      className="ap2-furnishing-counter"
                      aria-label={`${optionName} count`}
                    >
                      <button
                        type="button"
                        className="ap2-furnishing-step-btn"
                        onClick={() => decreaseFurnishingDetailCount(optionId)}
                        aria-label={`Decrease ${optionName}`}
                      >
                        <span aria-hidden="true">−</span>
                      </button>
                      <span className="ap2-furnishing-count">
                        {selectedItem.Count}
                      </span>
                      <button
                        type="button"
                        className="ap2-furnishing-step-btn"
                        onClick={() => increaseFurnishingDetailCount(optionId)}
                        aria-label={`Increase ${optionName}`}
                      >
                        <span aria-hidden="true">+</span>
                      </button>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    ) : null;
  };

  const cityOptions = useCities(stateId !== "0" ? stateId : "");

  const visiblePropertyTypeOptions = useMemo(() => {
    if (propertyFor === "PG") {
      return PROPERTY_TYPE_OPTIONS.PG;
    }
    return PROPERTY_TYPE_OPTIONS[buildingType] || [];
  }, [propertyFor, buildingType]);

  const onChangePropertyFor = (value) => {
    setPropertyFor(value);
    setPropertyType("");

    setShowBuiltUpArea(false);
    setShowSuperArea(false);
    setShowCarpetArea(false);

    if (value === "PG") {
      setBuildingType("11");
      const filteredPropertyTypes = lstSZType.filter(
        (type) => type.SectionId == "11",
      );
      setLstPropertyTypes(filteredPropertyTypes);

      return;
    }

    if (!["Residential", "Commercial"].includes(buildingType)) {
      setBuildingType("Residential");
    }

    if (value == "PG") {
      setShowCarpetArea(true);
    } else {
      setShowCarpetArea(false);
    }
  };

  const onChangeBuildingType = (sectionid) => {
    setBuildingType(sectionid);
    const filteredPropertyTypes = lstSZType.filter(
      (type) => type.SectionId == sectionid,
    );
    setLstPropertyTypes(filteredPropertyTypes);
    setPropertyType("");
  };

  const GetAllCitiesByStateId = async (stateId) => {
    try {
      const response = await fetch(CityURL + "GetCitiesByStateId/" + stateId, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tcn}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Cities request failed: ${response.status}`);
      }

      const result = await response.json();
      const filterdata = Array.isArray(result?.data)
        ? result.data.filter((item) => item.IsActive == true)
        : [];
      filterdata.unshift({ CityId: 0, CityName: "Select City" });
      return filterdata;
    } catch (error) {
      console.error("Error fetching Cities:", error);
    }
  };

  const GetAreasByCityId = async (cityId) => {
    try {
      const response = await fetch(AreaURL + "GetAreasByCityId/" + cityId, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tcn}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Areas request failed: ${response.status}`);
      }

      const result = await response.json();
      const filterdata = Array.isArray(result?.data)
        ? result.data.filter((item) => item.IsActive == true)
        : [];
      filterdata.unshift({ AreaId: 0, AreaName: "Select Area" });
      return filterdata;
    } catch (error) {
      console.error("Error fetching Areas:", error);
      return [];
    }
  };

  const onStateChange = (event) => {
    const stateid = event.target.value;
    setStateId(stateid);
    setCityId("0");
    setLstCity([]);
    setAreaId("0");
    setLstArea([]);

    if (stateid !== "0") {
      const fetchcities = async (stateid) => {
        try {
          const data = await GetAllCitiesByStateId(stateid);
          if (data) {
            setLstCity(data);
          }
        } catch (error) {
          console.error("Error fetching Cities:", error);
        }
      };

      fetchcities(stateid);
    }
  };

  const onCityChange = (event) => {
    const cityid = event.target.value;
    setCityId(cityid);
    setAreaId("0");
    setLstArea([]);
    setLocality("");

    if (cityid !== "0") {
      const fetchAreas = async (cityid) => {
        try {
          const data = await GetAreasByCityId(cityid);
          if (data) {
            setLstArea(data);
          }
        } catch (error) {
          console.error("Error fetching Areas:", error);
        }
      };

      fetchAreas(cityid);
    }
  };

  const onAreaChange = (event) => {
    const selectedAreaId = event.target.value;
    setAreaId(selectedAreaId);
    const selectedArea = (lstArea || []).find(
      (areaItem) => String(areaItem.AreaId) === String(selectedAreaId),
    );   
  };

  const onSubmit = (event) => {
    event.preventDefault();
  };

  const ValidateSubmit = async () => {
    try {
      if (!propertyFor || propertyFor.trim() === "") {
        enqueueSnackbar("Choose Property For!", { variant: "warning" });
        propertyForRef.current.focus();
        return false;
      }

      if (!buildingType || buildingType === "0") {
        enqueueSnackbar("Choose Building Type!", { variant: "warning" });
        buildingTypeRef.current.focus();
        return false;
      }

      if (!propertyType || propertyType === "0") {
        enqueueSnackbar("Choose Property Type!", { variant: "warning" });
        propertyTypeRef.current.focus();
        return false;
      }

      if (!stateId || stateId === "0") {
        enqueueSnackbar("Choose State!", { variant: "warning" });
        stateIdRef.current.focus();
        return false;
      }

      if (!cityId || cityId === "0") {
        enqueueSnackbar("Choose City!", { variant: "warning" });
        cityIdRef.current.focus();
        return false;
      }

      if (!areaId || areaId === "0") {
        enqueueSnackbar("Choose Area!", { variant: "warning" });
        areaRef.current.focus();
        return false;
      }

      if (!locality || locality.trim() === "") {
        enqueueSnackbar("Enter Locality / Area!", { variant: "warning" });
        localityRef.current.focus();
        return false;
      }

      if (!societyOrPgName || societyOrPgName.trim() === "") {
        enqueueSnackbar(
          `Enter ${propertyFor === "PG" ? "PG Name" : "Society / Apartment"}!`,
          { variant: "warning" },
        );
        societyOrPgNameRef.current.focus();
        return false;
      }

      if (!PropertyTitle || PropertyTitle.trim() === "") {
        enqueueSnackbar("Enter Property Title!", { variant: "warning" });
        propertyTitleRef.current.focus();
        return false;
      }

      if (!PropertyDescription || PropertyDescription.trim() === "") {
        enqueueSnackbar("Enter Property Description!", { variant: "warning" });
        propertyDescriptionRef.current.focus();
        return false;
      }

      if (propertyFor === "PG") {
        if (!roomType) {
          enqueueSnackbar("Choose Room Type!", { variant: "warning" });
          roomTypeRef.current.focus();
          return false;
        }

        if (!foodMeals) {
          enqueueSnackbar("Choose Food / Meals Option!", {
            variant: "warning",
          });
          foodMealsRef.current.focus();
          return false;
        }

        if (!suitableFor) {
          enqueueSnackbar("Choose Suitable For Option!", {
            variant: "warning",
          });
          suitableForRef.current.focus();
          return false;
        }

        if (!availableFor) {
          enqueueSnackbar("Choose Available For Option!", {
            variant: "warning",
          });
          availableForRef.current.focus();
          return false;
        }

        if (!foodChargesIncluded) {
          enqueueSnackbar("Choose Food Charges Included Option!", {
            variant: "warning",
          });
          foodChargesIncludedRef.current.focus();
          return false;
        }

        if (!electricityChargesIncluded) {
          enqueueSnackbar("Choose Electricity Charges Included Option!", {
            variant: "warning",
          });
          electricityChargesIncludedRef.current.focus();
          return false;
        }

        if (!noticePeriod) {
          enqueueSnackbar("Choose Notice Period Option!", {
            variant: "warning",
          });
          noticePeriodRef.current.focus();
          return false;
        }
      }

      if (propertyFor === "Sell" || propertyFor === "Rent") {
        if (builtUpArea === "") {
          enqueueSnackbar("Enter Built Up Area!", { variant: "warning" });
          builtUpAreaRef.current.focus();
          return false;
        } else {
          if (builtUpArea && isNaN(builtUpArea)) {
            enqueueSnackbar("Built Up Area must be a number!", {
              variant: "warning",
            });
            builtUpAreaRef.current.focus();
            return false;
          }

          const areaValue = parseFloat(builtUpArea);
          if (isNaN(areaValue) || areaValue <= 0) {
            enqueueSnackbar("Built Up Area must be a positive number!", {
              variant: "warning",
            });
            builtUpAreaRef.current.focus();
            return false;
          }

          if (!builtUpAreaUnit || builtUpAreaUnit === "0") {
            enqueueSnackbar("Choose Land/ Area Unit!", { variant: "warning" });
            builtUpAreaUnitRef.current.focus();
            return false;
          }
        }
      }

      if (showBuiltUpArea) {
        if (builtUpMeasure === "") {
          enqueueSnackbar("Enter Built Up Measure!", { variant: "warning" });
          builtUpMeasureRef.current.focus();
          return false;
        } else {
          if (builtUpMeasure && isNaN(builtUpMeasure)) {
            enqueueSnackbar("Built Up Measure must be a number!", {
              variant: "warning",
            });
            builtUpMeasureRef.current.focus();
            return false;
          }

          const measureValue = parseFloat(builtUpMeasure);
          if (isNaN(measureValue) || measureValue <= 0) {
            enqueueSnackbar("Built Up Measure must be a positive number!", {
              variant: "warning",
            });
            builtUpMeasureRef.current.focus();
            return false;
          }

          if (!builtUpMeasureUnit || builtUpMeasureUnit == "0") {
            enqueueSnackbar("Choose Built Up Measure Unit!", {
              variant: "warning",
            });
            builtUpMeasureUnitRef.current.focus();
            return false;
          }
        }
      }

      if (showCarpetArea) {
        if (carpetArea === "") {
          enqueueSnackbar("Enter Carpet Area!", { variant: "warning" });
          carpetAreaRef.current.focus();
          return false;
        } else {
          if (carpetArea && isNaN(carpetArea)) {
            enqueueSnackbar("Carpet Area must be a number!", {
              variant: "warning",
            });
            carpetAreaRef.current.focus();
            return false;
          }
          const carpetAreaValue = parseFloat(carpetArea);
          if (isNaN(carpetAreaValue) || carpetAreaValue <= 0) {
            enqueueSnackbar("Carpet Area must be a positive number!", {
              variant: "warning",
            });
            carpetAreaRef.current.focus();
            return false;
          }
          if (!carpetAreaUnit || carpetAreaUnit === "0") {
            enqueueSnackbar("Choose Carpet Area Unit!", { variant: "warning" });
            carpetAreaUnitRef.current.focus();
            return false;
          }
        }
      }

      if (showSuperArea) {
        if (superArea === "") {
          enqueueSnackbar("Enter Super Area!", { variant: "warning" });
          superAreaRef.current.focus();
          return false;
        } else {
          if (superArea && isNaN(superArea)) {
            enqueueSnackbar("Super Area must be a number!", {
              variant: "warning",
            });
            superAreaRef.current.focus();
            return false;
          }
          const superAreaValue = parseFloat(superArea);
          if (isNaN(superAreaValue) || superAreaValue <= 0) {
            enqueueSnackbar("Super Area must be a positive number!", {
              variant: "warning",
            });
            superAreaRef.current.focus();
            return false;
          }
          if (!superAreaUnit || superAreaUnit === "0") {
            enqueueSnackbar("Choose Super Area Unit!", { variant: "warning" });
            superAreaUnitRef.current.focus();
            return false;
          }
        }
      }

      //Property Price Validations
      if (propertyFor === "Sell") {
        if (price === "") {
          enqueueSnackbar("Enter Price!", { variant: "warning" });
          priceRef.current.focus();
          return false;
        } else {
          if (price && isNaN(price)) {
            enqueueSnackbar("Price must be a number!", { variant: "warning" });
            priceRef.current.focus();
            return false;
          }
          const priceValue = parseFloat(price);
          if (isNaN(priceValue) || priceValue <= 0) {
            enqueueSnackbar("Price must be a positive number!", {
              variant: "warning",
            });
            priceRef.current.focus();
            return false;
          }
          if (!PricePerAreaUnit || PricePerAreaUnit === "0") {
            enqueueSnackbar("Choose Price Per Area Unit!", {
              variant: "warning",
            });
            pricePerAreaUnitRef.current.focus();
            return false;
          }
        }

        if (
          bookingAmount === "" ||
          bookingAmount === 0 ||
          isNaN(bookingAmount)
        ) {
          enqueueSnackbar("Enter Booking Amount!", { variant: "warning" });
          bookingAmountRef.current.focus();
          return false;
        }
      } else {
        if (price === "") {
          enqueueSnackbar("Enter Price!", { variant: "warning" });
          priceRef.current.focus();
          return false;
        } else {
          if (price && isNaN(price)) {
            enqueueSnackbar("Price must be a number!", { variant: "warning" });
            priceRef.current.focus();
            return false;
          }
          const priceValue = parseFloat(price);
          if (isNaN(priceValue) || priceValue <= 0) {
            enqueueSnackbar("Price must be a positive number!", {
              variant: "warning",
            });
            priceRef.current.focus();
            return false;
          }
        }

        if (maintenanceCharges === "") {
        } else {
          if (maintenanceCharges && isNaN(maintenanceCharges)) {
            enqueueSnackbar("Maintenance Charges must be a number!", {
              variant: "warning",
            });
            maintenanceChargesRef.current.focus();
            return false;
          }
        }

        if (securityDeposit === "") {
        } else {
          if (securityDeposit && isNaN(securityDeposit)) {
            enqueueSnackbar("Security Deposit must be a number!", {
              variant: "warning",
            });
            securityDepositRef.current.focus();
            return false;
          }
        }
      }

      if (propertyFor === "Sell") {
        //Property Availability Validations
        if (possessionBy === "" || possessionBy === "0") {
          enqueueSnackbar("Choose Possession By!", { variant: "warning" });
          possessionByRef.current.focus();
          return false;
        }

        if (propertyOnFloor === "" || propertyOnFloor === "0") {
          enqueueSnackbar("Choose Property On Floor!", { variant: "warning" });
          propertyOnFloorRef.current.focus();
          return false;
        }
      }

      if (numberOfRooms === "" || numberOfRooms === "0") {
        enqueueSnackbar("Choose Number of Rooms!", { variant: "warning" });
        numberOfRoomsRef.current.focus();
        return false;
      }

      if (washroomCount === "" || washroomCount === "0") {
        enqueueSnackbar("Choose Number of Washrooms!", { variant: "warning" });
        washroomCountRef.current.focus();
        return false;
      }

      if (furnishingStatus === "" || furnishingStatus === "0") {
        enqueueSnackbar("Choose Furnishing Status!", { variant: "warning" });
        furnishingStatusRef.current.focus();
        return false;
      }

      debugger;
      if (furnishingDetails.length === 0 && furnishingStatus != 206) {
        enqueueSnackbar("Choose Furnishing Details!", { variant: "warning" });
        furnishingDetailsRef.current.focus();
        return false;
      }

      if (facing === "" || facing === "0") {
        enqueueSnackbar("Choose Facing!", { variant: "warning" });
        facingRef.current.focus();
        return false;
      }

      if (ageOfProperty === "" || ageOfProperty === "0") {
        enqueueSnackbar("Choose Age of Property!", { variant: "warning" });
        ageOfPropertyRef.current.focus();
        return false;
      }

      if (ownershipStatus === "" || ownershipStatus === "0") {
        enqueueSnackbar("Choose Ownership Status!", { variant: "warning" });
        ownershipStatusRef.current.focus();
        return false;
      }

      if (parking === "" || parking === "0") {
        enqueueSnackbar("Choose Parking!", { variant: "warning" });
        parkingRef.current.focus();
        return false;
      } else {
        const vendorid = JSON.parse(localStorage.getItem("id"));
        const descriptionwithoutHTML = PropertyDescription.replace(
          /<[^>]+>/g,
          "",
        );

        debugger;
        const createPropertyObject = () => {
          return {
            PropertyId: PropertyId,
            VendorId: vendorid,
            PropertyGeneratedId: "",
            PropertyTitle: PropertyTitle,
            PropertyDescription: PropertyDescription,
            MetaTitle: PropertyTitle,
            MetaDescription: descriptionwithoutHTML,
            MetaKeyword:
              PropertyTitle + "," + descriptionwithoutHTML + "," + address,
            AutoGeneratedURL: "",
            PropertyFor: propertyFor,
            BuildingTypeId: parseInt(buildingType) || 0,
            PropertyTypeId: parseInt(propertyType) || 0,
            StateId: parseInt(stateId) || 0,
            CityId: parseInt(cityId) || 0,
            AreaId: parseInt(areaId) || 0,
            Area: locality,
            PinCode: "",
            Society_PG_Apartment_Name: societyOrPgName,
            Address: address,
            LandSize: builtUpArea,
            LandSizeUnitSizeId: parseInt(builtUpAreaUnit) || 0,
            BuiltUpArea: builtUpMeasure,
            BuiltUpAreaUnitSizeId: parseInt(builtUpMeasureUnit) || 0,
            CarpetArea: carpetArea,
            CarpetAreaUnitSizeId: parseInt(carpetAreaUnit) || 0,
            SuperArea: superArea,
            SuperAreaUnitSizeId: parseInt(superAreaUnit) || 0,
            ExpectedPrice: price,
            ExpectedPricePerUnitSizeId: parseInt(PricePerAreaUnit) || 0,
            BookingAmount: bookingAmount,
            Maintenance: maintenanceCharges,
            RentPerMonth: price,
            PossessionById: parseInt(possessionBy) || 0,
            PropertyOnTheFloorId: parseInt(propertyOnFloor) || 0,
            NoofRoomId: parseInt(numberOfRooms) || 0,
            NoofWashroomId: parseInt(washroomCount) || 0,
            FurnishingStatusId: parseInt(furnishingStatus) || 0,
            FacingId: parseInt(facing) || 0,
            AgeofPropertyId: parseInt(ageOfProperty) || 0,
            OwnershipStatusId: parseInt(ownershipStatus) || 0,
            ParkingId: parseInt(parking) || 0,
            RoomTypeId: parseInt(roomType) || 0,
            FoodMealsId: parseInt(foodMeals) || 0,
            SuitableForId: parseInt(suitableFor) || 0,
            AvailableId: parseInt(availableFor) || 0,
            NoticePeriodId: parseInt(noticePeriod) || 0,
            FoodChargesIncluded: foodChargesIncluded,
            ElectricityChargesIncluded: electricityChargesIncluded,
            SecurityDeposit: securityDeposit,
            Latitude: "",
            Longitude: "",
            EmbdedMapURL: "",
            Value: "",
            IsFeatured: false,
            FeatureIndex: 0,
            PostedBy: parseInt(vendorid) || 0,
            IsWantFeatureProperty: false,
            IsActive: true,
            CreatedBy: parseInt(vendorid) || 0,
            CreatedOn: null,
            ModifiedBy: 0,
            ModifiedOn: null,
            _lstRulesAllowedTypeId: allowedSelectedRules,
            _lstRulesNotAllowedTypeId: notAllowedSelectedRules,
            _lstPropertyFurnishDetail: furnishingDetails,
          };
        };

        const json = JSON.stringify(createPropertyObject());

        let response = null;

        if (!edit) {
          response = await fetch(NewProperty + "InsertNewProperty", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tcn}`,
            },
            body: json,
          });
        } else {
          response = await fetch(
            NewProperty + "UpdateNewProperty/" + PropertyId,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tcn}`,
              },
              body: json,
            },
          );
        }

        // Check if response status is ok and has content
        if (!response.ok) {
          if (response.status === 401) {
            enqueueSnackbar(
              "Unauthorized: Your session has expired. Please login again.",
              { variant: "error" },
            );
            localStorage.clear();
            window.location.href = "/";
          }
          throw new Error(`Server error: ${response.status}`);
        }

        // Get the response text to check if it's empty
        const responseText = await response.text();

        if (!responseText || responseText.trim() === "") {
          throw new Error("Server returned an empty response");
        }

        // Parse the JSON from the text
        let result;
        try {
          result = JSON.parse(responseText);
        } catch (parseError) {
          throw new Error(`Invalid JSON response from server: ${responseText}`);
        }

        if (result.Message == "Success") {
          setTimeout(() => {
            window.location.reload();
          }, 500);

          edit
            ? enqueueSnackbar("Property updated successfully!", {
                variant: "success",
              })
            : enqueueSnackbar("Property added successfully!", {
                variant: "success",
              });
          // setEdit(false);
        } else if (result.Message == "FreePostUsed") {
          enqueueSnackbar(
            "You have used your free post credits. Subscribe for more!!",
            { variant: "success" },
          );
          window.open("/buy-subscription", "_blank");
        } else if (result.Message == "FreePostUsedandAppliedForSubscription") {
          enqueueSnackbar(
            "Your request to increase post credits for property listings is being processed and will be approved by the admin soon!",
            { variant: "warning" },
          );
          window.open("/buy-subscription", "_blank");
        } else if (result.Message == "BalanceOver") {
          enqueueSnackbar("Your Credit is over. Subscribe for more!!", {
            variant: "warning",
          });
          window.open("/buy-subscription", "_blank");
        } else {
          enqueueSnackbar(result.message || "Failed to add property", {
            variant: "warning",
          });
        }
      }
    } catch (error) {
      console.error("Error adding property:", error);
      enqueueSnackbar("Error adding property. Please try again.", {
        variant: "error",
      });
    }
  };

  const fnEditPropertyDetails = async (propertyId) => {
    try {
      const propertyItem = myProperties.find((p) => p.PropertyId == propertyId);
      if (!propertyItem) {
        enqueueSnackbar("Property not found.", { variant: "error" });
        return;
      }

      setPropertyId(propertyItem.PropertyId);
      // Basic info
      setPropertyFor(propertyItem.PropertyFor || "Sell");
      setBuildingType(
        propertyItem.BuildingTypeId ? String(propertyItem.BuildingTypeId) : "0",
      );

      // Populate property types based on building type
      const filteredPropertyTypes = lstSZType.filter(
        (type) => type.SectionId == String(propertyItem.BuildingTypeId),
      );
      setLstPropertyTypes(filteredPropertyTypes);
      setPropertyType(
        propertyItem.PropertyTypeId ? String(propertyItem.PropertyTypeId) : "0",
      );

      // Location
      setStateId(propertyItem.StateId ? String(propertyItem.StateId) : "0");
      if (propertyItem.StateId) {
        const cities = await GetAllCitiesByStateId(propertyItem.StateId);
        if (Array.isArray(cities)) setLstCity(cities);
      }
      setCityId(propertyItem.CityId ? String(propertyItem.CityId) : "0");
      let areas = [];
      if (propertyItem.CityId) {
        areas = await GetAreasByCityId(propertyItem.CityId);
        if (Array.isArray(areas)) setLstArea(areas);
      }
      setAreaId(propertyItem.AreaId ? String(propertyItem.AreaId) : "0");
      const selectedArea = (areas || []).find(
        (item) => String(item.AreaId) === String(propertyItem.AreaId),
      );

      setLocality(propertyItem.Area || "");
      setSocietyOrPgName(propertyItem.Society_PG_Apartment_Name || "");
      setAddress(propertyItem.Address || "");

      // Title & Description
      setPropertyTitle(propertyItem.PropertyTitle || "");
      setPropertyDescription(propertyItem.PropertyDescription || "");

      // PG specific
      setRoomType(
        propertyItem.RoomTypeId ? String(propertyItem.RoomTypeId) : "",
      );
      setFoodMeals(
        propertyItem.FoodMealsId ? String(propertyItem.FoodMealsId) : "",
      );
      setSuitableFor(
        propertyItem.SuitableForId ? String(propertyItem.SuitableForId) : "",
      );
      setAvailableFor(
        propertyItem.AvailableId ? String(propertyItem.AvailableId) : "",
      );
      setNoticePeriod(
        propertyItem.NoticePeriodId ? String(propertyItem.NoticePeriodId) : "",
      );
      setAllowedSelectedRules(
        Array.isArray(propertyItem._lstPGRuleAllowed)
          ? propertyItem._lstPGRuleAllowed
          : [],
      );
      setNotAllowedSelectedRules(
        Array.isArray(propertyItem._lstPGRuleNotAllowed)
          ? propertyItem._lstPGRuleNotAllowed
          : [],
      );

      setFoodChargesIncluded(
        propertyItem.FoodChargesIncluded
          ? String(propertyItem.FoodChargesIncluded)
          : "",
      );
      setElectricityChargesIncluded(
        propertyItem.ElectricityChargesIncluded
          ? String(propertyItem.ElectricityChargesIncluded)
          : "",
      );

      // Area / sizes
      setBuiltUpArea(
        propertyItem.LandSize ? String(propertyItem.LandSize) : "",
      );
      setBuiltUpAreaUnit(
        propertyItem.LandSizeUnitSizeId
          ? String(propertyItem.LandSizeUnitSizeId)
          : "0",
      );
      setBuiltUpMeasure(
        propertyItem.BuiltUpArea ? String(propertyItem.BuiltUpArea) : "",
      );
      setBuiltUpMeasureUnit(
        propertyItem.BuiltUpAreaUnitSizeId
          ? String(propertyItem.BuiltUpAreaUnitSizeId)
          : "0",
      );
      setShowBuiltUpArea(!!propertyItem.BuiltUpArea);

      setCarpetArea(
        propertyItem.CarpetArea ? String(propertyItem.CarpetArea) : "",
      );
      setCarpetAreaUnit(
        propertyItem.CarpetAreaUnitSizeId
          ? String(propertyItem.CarpetAreaUnitSizeId)
          : "0",
      );
      setShowCarpetArea(!!propertyItem.CarpetArea);

      setSuperArea(
        propertyItem.SuperArea ? String(propertyItem.SuperArea) : "",
      );
      setSuperAreaUnit(
        propertyItem.SuperAreaUnitSizeId
          ? String(propertyItem.SuperAreaUnitSizeId)
          : "0",
      );
      setShowSuperArea(!!propertyItem.SuperArea);

      // Price & charges
      setPrice(
        propertyItem.ExpectedPrice
          ? String(propertyItem.ExpectedPrice)
          : propertyItem.RentPerMonth
            ? String(propertyItem.RentPerMonth)
            : "",
      );
      setPricePerAreaUnit(
        propertyItem.ExpectedPricePerUnitSizeId
          ? String(propertyItem.ExpectedPricePerUnitSizeId)
          : "0",
      );
      setMaintenanceCharges(
        propertyItem.Maintenance ? String(propertyItem.Maintenance) : "",
      );
      setSecurityDeposit(
        propertyItem.SecurityDeposit
          ? String(propertyItem.SecurityDeposit)
          : "",
      );
      setBookingAmount(
        propertyItem.BookingAmount ? String(propertyItem.BookingAmount) : "",
      );

      // Availability & attributes
      setPossessionBy(
        propertyItem.PossessionById ? String(propertyItem.PossessionById) : "",
      );
      setPropertyOnFloor(
        propertyItem.PropertyOnTheFloorId
          ? String(propertyItem.PropertyOnTheFloorId)
          : "",
      );
      setNumberOfRooms(
        propertyItem.NoofRoomId ? String(propertyItem.NoofRoomId) : "",
      );
      setWashroomCount(
        propertyItem.NoofWashroomId ? String(propertyItem.NoofWashroomId) : "",
      );
      setFurnishingStatus(
        propertyItem.FurnishingStatusId
          ? String(propertyItem.FurnishingStatusId)
          : "",
      );
      setFacing(propertyItem.FacingId ? String(propertyItem.FacingId) : "");
      setAgeOfProperty(
        propertyItem.AgeofPropertyId
          ? String(propertyItem.AgeofPropertyId)
          : "",
      );
      setOwnershipStatus(
        propertyItem.OwnershipStatusId
          ? String(propertyItem.OwnershipStatusId)
          : "",
      );
      setAvailableForRent(
        propertyItem.AvailableId ? String(propertyItem.AvailableId) : "",
      );
      setParking(propertyItem.ParkingId ? String(propertyItem.ParkingId) : "");

      // Normalize furnishing details to expected shape: { FurnishId: Number, Count: Number }
      setFurnishingDetails(
        Array.isArray(propertyItem._lstPropertyFurnishDetail)
          ? propertyItem._lstPropertyFurnishDetail.map((it) => ({
              FurnishId: Number(
                it.FurnishId ?? it.furnishId ?? it.FurnishID ?? it.Id ?? 0,
              ),
              Count: Math.max(1, Number(it.Count ?? it.count ?? 1) || 1),
            }))
          : [],
      );

      setEdit(true);
      // reset pagination to first page and bring form into view
      setPage(1);
      if (propertyForRef && propertyForRef.current)
        propertyForRef.current.scrollIntoView({ behavior: "smooth" });
    } catch (error) {
      console.error("Error populating property details:", error);
      enqueueSnackbar("Error loading property details. Please try again.", {
        variant: "error",
      });
    }
  };

  return (
    <div className="ap2-page">
      <div className="widget-box-2 mb-20 ap2-wrap">
        <h5 className="title ap2-section-title">Property Information</h5>

        <div className="ap2-form">
          <div className="ap2-row">
            <label className="ap2-label" ref={propertyForRef}>
              Property For <span>*</span>
            </label>
            <div className="ap2-control ap2-chip-list">
              {PROPERTY_FOR_OPTIONS.map((option, index) => (
                <button
                  key={option}
                  type="button"
                  className={`ap2-chip ${propertyFor === option ? "is-active" : ""}`}
                  onClick={() => onChangePropertyFor(option)}
                  ref={index == 0 ? propertyForRef : null}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>

          {propertyFor !== "PG" ? (
            <div className="ap2-row">
              <label className="ap2-label">
                Building Type <span>*</span>
              </label>

              <div className="ap2-control ap2-chip-list">
                {lstZSections
                  .filter(
                    (section) =>
                      section.SectionId == "11" || section.SectionId == "12",
                  )
                  .map((option, index) => (
                    <button
                      key={option.SectionId}
                      type="button"
                      className={`ap2-chip ${String(buildingType) === String(option.SectionId) ? "is-active" : ""}`}
                      onClick={() => onChangeBuildingType(option.SectionId)}
                      ref={index == 0 ? buildingTypeRef : null}
                    >
                      {option.SectionName}
                    </button>
                  ))}
              </div>
            </div>
          ) : null}

          <div className="ap2-row">
            <label className="ap2-label">
              Property Type <span>*</span>
            </label>
            <div className="ap2-control ap2-chip-list ap2-chip-list-wide">
              {lstPropertyTypes.map((option, index) => (
                <button
                  key={option.TypeId}
                  type="button"
                  className={`ap2-chip ${String(propertyType) === String(option.TypeId) ? "is-active" : ""}`}
                  onClick={() => setPropertyType(option.TypeId)}
                  ref={index == 0 ? propertyTypeRef : null}
                >
                  {option.TypeName}
                </button>
              ))}
            </div>
          </div>

          <div className="ap2-row">
            <label htmlFor="ap2-state" className="ap2-label">
              State <span>*</span>
            </label>
            <div className="ap2-control">
              <select
                id="ap2-state"
                className="form-control ap-price-select ap-price-rect-input ap-price-select-half"
                value={stateId}
                onChange={(e) => onStateChange(e)}
                ref={stateIdRef}
              >
                {lstState.map((stateItem) => (
                  <option key={stateItem.StateId} value={stateItem.StateId}>
                    {stateItem.StateName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="ap2-row">
            <label htmlFor="ap2-cityId" className="ap2-label">
              City <span>*</span>
            </label>
            <div className="ap2-control">
              <select
                id="ap2-cityId"
                className="form-control ap-price-select ap-price-rect-input ap-price-select-half"
                value={cityId}
                onChange={(event) => onCityChange(event)}
                disabled={stateId === "0"}
                ref={cityIdRef}
              >
                {(lstCity || []).map((cityItem) => (
                  <option key={cityItem.CityId} value={cityItem.CityId}>
                    {cityItem.CityName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {stateId !== "0" && cityId !== "0" ? (
            <div className="ap2-row">
              <label htmlFor="ap2-areaId" className="ap2-label">
                Area <span>*</span>
              </label>
              <div className="ap2-control">
                <select
                  id="ap2-areaId"
                  className="form-control ap-price-select ap-price-rect-input ap-price-select-half"
                  value={areaId}
                  onChange={onAreaChange}
                  ref={areaRef}
                >
                  {(lstArea || []).map((areaItem) => (
                    <option key={areaItem.AreaId} value={areaItem.AreaId}>
                      {areaItem.AreaName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ) : null}

          {stateId !== "0" && cityId !== "0" && areaId !== "0" ? (
            <div className="ap2-row">
              <label htmlFor="ap2-locality" className="ap2-label">
                Locality Details <span>*</span>
              </label>
              <div className="ap2-control">
                <input
                  id="ap2-locality"
                  type="text"
                  className="form-control"
                  placeholder="Enter Locality / Area Details"
                  value={locality}
                  onChange={(event) => setLocality(event.target.value)}
                  maxLength={100}
                  ref={localityRef}
                />
              </div>
            </div>
          ) : null}

          <div className="ap2-row">
            <label htmlFor="ap2-pg-society" className="ap2-label">
              {propertyFor === "PG" ? "PG Name" : "Society / Apartment"}
              <span>*</span>
            </label>
            <div className="ap2-control">
              <input
                id="ap2-pg-society"
                type="text"
                className="form-control"
                placeholder={
                  propertyFor === "PG"
                    ? "Enter PG Name"
                    : "Name of Apartment/Society"
                }
                value={societyOrPgName}
                onChange={(event) => setSocietyOrPgName(event.target.value)}
                maxLength={120}
                ref={societyOrPgNameRef}
              />
            </div>
          </div>

          <div className="ap2-row ap2-row-top">
            <label htmlFor="ap2-address" className="ap2-label">
              Address
            </label>
            <div className="ap2-control">
              <input
                id="ap2-address"
                className="form-control"
                placeholder="Enter Property Address"
                value={address}
                onChange={(event) => setAddress(event.target.value)}
                ref={addressRef}
              />
            </div>
          </div>
          <div className="ap2-row">
            <label htmlFor="ap2-pg-society" className="ap2-label">
              Title:<span>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="enter Title for your property listing"
              value={PropertyTitle}
              onChange={(e) => setPropertyTitle(e.target.value)}
              maxLength={300}
              ref={propertyTitleRef}
            />
          </div>
          <div className="ap2-row">
            <label htmlFor="ap2-pg-society" className="ap2-label">
              Description:<span>*</span>
            </label>
            <ReactQuill
              theme="snow"
              ref={propertyDescriptionRef}
              value={PropertyDescription}
              onChange={(value) => setPropertyDescription(value)}
              placeholder="Your Description"
              className="h-96 textarea" // Better than "textarea" - use h-64, h-96, etc.
              style={{ height: "20rem" }}
              modules={{
                toolbar: [
                  // Headers & font size
                  [{ header: [1, 2, 3, 4, 5, 6, false] }],
                  [{ size: ["small", false, "large", "huge"] }],

                  // Formatting
                  ["bold", "italic", "underline", "strike"],

                  // Lists & alignment
                  [{ list: "ordered" }, { list: "bullet" }],
                  [{ align: [] }],

                  // Links, images, video
                  ["blockquote", "code-block"],
                  [{ indent: "-1" }, { indent: "+1" }],
                  ["link", "image", "video"],

                  // Clean formatting
                  ["clean"],
                ],
                history: {
                  delay: 2000,
                  maxStack: 100,
                  userOnly: true,
                },
              }}
            />
          </div>
        </div>
      </div>

      <div className="ap2-conditional-section">
        {propertyFor === "PG" ? (
          <div className="widget-box-2 mb-20 ap-price-wrap ap-pg-wrap">
            <h5 className="title">PG Details</h5>
            <div className="ap-price-form ap-pg-form">
              {renderToggleChipGroup({
                label: "Room Type",
                options: lstPGRoomType,
                value: roomType,
                setValue: setRoomType,
                required: true,
                itemref: roomTypeRef,
              })}
              {renderToggleChipGroup({
                label: "Food / Meals",
                options: lstPGFooDMeal,
                value: foodMeals,
                setValue: setFoodMeals,
                required: true,
                itemref: foodMealsRef,
              })}
              {renderToggleChipGroup({
                label: "Suitable For",
                options: lstPGSuitableFor,
                value: suitableFor,
                setValue: setSuitableFor,
                required: true,
                itemref: suitableForRef,
              })}
              {renderToggleChipGroup({
                label: "Available for",
                options: lstPGAvailablefor,
                value: availableFor,
                setValue: setAvailableFor,
                required: true,
                itemref: availableForRef,
              })}
              {renderToggleChipGroup({
                label: "Food Charges Included",
                options: YES_NO_OPTIONS,
                value: foodChargesIncluded,
                setValue: setFoodChargesIncluded,
                required: true,
                itemref: foodChargesIncludedRef,
              })}
              {renderToggleChipGroup({
                label: "Electricity Charges Included",
                options: YES_NO_OPTIONS,
                value: electricityChargesIncluded,
                setValue: setElectricityChargesIncluded,
                required: true,
                itemref: electricityChargesIncludedRef,
              })}
              {renderToggleChipGroup({
                label: "Notice Period(Days)",
                options: lstPGNoticePeriod,
                value: noticePeriod,
                setValue: setNoticePeriod,
                required: true,
                itemref: noticePeriodRef,
              })}

              <div className="ap-price-row ap-price-row-top  ap-pg-row">
                <label className="ap-price-label ap-pg-label">
                  Rules Allowed
                </label>
                <div className="ap-price-control ap-price-chip-list ap-pg-chip-list">
                  {lstPGRulesAllowed.map((rule) => (
                    <button
                      key={rule.TypeId}
                      type="button"
                      className={`ap2-chip ${allowedSelectedRules.some((item) => item.TypeId === rule.TypeId) ? "is-active" : ""}`}
                      onClick={() => toggleRuleAllowed(rule)}
                    >
                      {rule.TypeName}
                    </button>
                  ))}
                </div>
              </div>
              <div className="ap-price-row ap-price-row-top ap-pg-row">
                <label className="ap-price-label ap-pg-label">
                  Rules Not Allowed
                </label>
                <div className="ap-price-control ap-price-chip-list ap-pg-chip-list ap-pg-rules-list">
                  {lstPGRulesNotAllowed.map((rule) => (
                    <button
                      key={rule.TypeId}
                      type="button"
                      className={`ap2-chip ${notAllowedSelectedRules.some((item) => item.TypeId === rule.TypeId) ? "is-active" : ""}`}
                      onClick={() => toggleRuleNotAllowed(rule)}
                    >
                      {rule.TypeName}
                    </button>
                  ))}
                </div>
              </div>

              {/* <div className="box-btn ap-price-actions ap-pg-actions">
          <button type="submit" className="tf-btn primary">
            Save &amp; Continue <i className="icon icon-arrow-right" />
          </button>
        </div> */}
            </div>
          </div>
        ) : null}

        <div className="widget-box-2 mb-20 ap-price-wrap">
          <h5 className="title ap-price-section-title">
            Property Price : {propertyFor}
          </h5>
          <div className="ap-price-form">
            {(propertyFor === "Sell" || propertyFor === "Rent") && (
              <>
                <div className="ap-price-row">
                  <label className="ap-price-label">
                    Area/ Land Size <span>*</span>
                    <span className="ap-price-help">?</span>
                  </label>
                  <div className="ap-price-control">
                    <div className="ap-price-area-group ap-price-square-group">
                      <input
                        type="text"
                        className="form-control ap-price-input ap-price-rect-input ap-price-square-input"
                        placeholder="Area/ Land Size"
                        value={builtUpArea}
                        onChange={(event) => setBuiltUpArea(event.target.value)}
                        ref={builtUpAreaRef}
                      />
                      <select
                        className="form-control ap-price-select ap-price-unit-select ap-price-square-select"
                        value={builtUpAreaUnit}
                        onChange={(event) => {
                          setBuiltUpAreaUnit(event.target.value);
                          setPricePerAreaUnit(event.target.value);
                        }}
                        ref={builtUpAreaUnitRef}
                      >
                        {lstUnitArea.map((areaUnit) => (
                          <option key={areaUnit.TypeId} value={areaUnit.TypeId}>
                            {areaUnit.TypeName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="ap-price-extra-actions">
                      {!showBuiltUpArea ? (
                        <button
                          type="button"
                          className="ap-price-link"
                          onClick={() => setShowBuiltUpArea(true)}
                        >
                          Add Built Up Area
                        </button>
                      ) : null}
                      {!showCarpetArea ? (
                        <button
                          type="button"
                          className="ap-price-link"
                          onClick={() => setShowCarpetArea(true)}
                        >
                          Add Carpet Area
                        </button>
                      ) : null}
                      {!showSuperArea ? (
                        <button
                          type="button"
                          className="ap-price-link"
                          onClick={() => setShowSuperArea(true)}
                        >
                          Add Super Area
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              </>
            )}

            {showBuiltUpArea
              ? renderAreaField(
                  "Built Up Area",
                  builtUpMeasure,
                  setBuiltUpMeasure,
                  builtUpMeasureUnit,
                  setBuiltUpMeasureUnit,
                  "ap-price-built-up-area",
                  lstUnitArea,
                  () => setShowBuiltUpArea(false),
                  builtUpMeasureRef,
                  builtUpMeasureUnitRef,
                )
              : null}
            {showCarpetArea
              ? renderAreaField(
                  "Carpet Area",
                  carpetArea,
                  setCarpetArea,
                  carpetAreaUnit,
                  setCarpetAreaUnit,
                  "ap-price-carpet-area",
                  lstUnitArea,
                  () => setShowCarpetArea(false),
                  carpetAreaRef,
                  carpetAreaUnitRef,
                )
              : null}
            {showSuperArea
              ? renderAreaField(
                  "Super Area",
                  superArea,
                  setSuperArea,
                  superAreaUnit,
                  setSuperAreaUnit,
                  "ap-price-super-area",
                  lstUnitArea,
                  () => setShowSuperArea(false),
                  superAreaRef,
                  superAreaUnitRef,
                )
              : null}

            <div className="ap-price-row">
              <label className="ap-price-label">
                {isflag ? "Rent" : "Expected Price"} <span>*</span>
              </label>
              {propertyFor != "Sell" ? (
                <>
                  <div className="ap-price-control">
                    <div className="ap-price-money-group">
                      <input
                        type="text"
                        className="form-control ap-price-input ap-price-rect-input ap-price-money-input ap-price-money-input-with-suffix"
                        placeholder={
                          isflag ? "₹ Enter Rent" : "₹ Enter Total Price"
                        }
                        value={price}
                        onChange={(event) => setPrice(event.target.value)}
                        ref={priceRef}
                      />
                      <span className="ap-price-suffix">
                        {isflag ? "/Month" : ""}
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="ap-price-control">
                    <div className="ap-price-area-group ap-price-square-group">
                      <input
                        type="text"
                        className="form-control ap-price-input ap-price-rect-input ap-price-square-input"
                        placeholder={
                          isflag ? "₹ Enter Rent" : "₹ Enter Total Price"
                        }
                        value={price}
                        onChange={(event) => setPrice(event.target.value)}
                        ref={priceRef}
                      />
                      <select
                        className="form-control ap-price-select ap-price-unit-select ap-price-square-select"
                        value={PricePerAreaUnit}
                        onChange={(event) =>
                          setPricePerAreaUnit(event.target.value)
                        }
                        ref={pricePerAreaUnitRef}
                      >
                        {lstUnitArea.map((areaUnit) => (
                          <option key={areaUnit.TypeId} value={areaUnit.TypeId}>
                            {areaUnit.TypeName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </>
              )}
            </div>

            {isflag ? (
              <>
                <div className="ap-price-row">
                  <label className="ap-price-label">Maintenance Charges</label>
                  <div className="ap-price-control">
                    <div className="ap-price-money-group ap-price-money-group-sm">
                      <input
                        type="text"
                        className="form-control ap-price-input ap-price-rect-input ap-price-money-input ap-price-money-input-full"
                        placeholder="₹ Maintenance Charges"
                        value={maintenanceCharges}
                        onChange={(event) =>
                          setMaintenanceCharges(event.target.value)
                        }
                        ref={maintenanceChargesRef}
                      />
                    </div>
                  </div>
                </div>

                <div className="ap-price-row">
                  <label className="ap-price-label">Security Deposit</label>
                  <div className="ap-price-control">
                    <div className="ap-price-money-group ap-price-money-group-sm">
                      <input
                        type="text"
                        className="form-control ap-price-input ap-price-rect-input ap-price-money-input ap-price-money-input-full"
                        placeholder="₹ Security Deposit"
                        value={securityDeposit}
                        onChange={(event) =>
                          setSecurityDeposit(event.target.value)
                        }
                        ref={securityDepositRef}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="ap-price-row">
                  <label className="ap-price-label">Booking Amount</label>
                  <div className="ap-price-control">
                    <div className="ap-price-money-group ap-price-money-group-sm">
                      <input
                        type="text"
                        className="form-control ap-price-input ap-price-rect-input ap-price-money-input ap-price-money-input-full"
                        placeholder="₹ Booking Amount"
                        value={bookingAmount}
                        onChange={(event) =>
                          setBookingAmount(event.target.value)
                        }
                        ref={bookingAmountRef}
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="ap-price-row">
                  <label className="ap-price-label">Maintenance Charges</label>

                  <div className="ap-price-control">
                    <div className="ap-price-money-group ap-price-money-group-sm">
                      <input
                        type="text"
                        className="form-control ap-price-input ap-price-rect-input ap-price-money-input ap-price-money-input-full"
                        placeholder="₹ Maintenance Charges"
                        value={maintenanceCharges}
                        onChange={(event) => setMaintenanceCharges(event.target.value)}
                        ref={maintenanceChargesRef}
                      />
                    </div>
                  </div>
                </div> */}
              </>
            )}

            <div className="ap-price-divider" />

            <div
              className="ap-price-section-title"
              style={{ marginBottom: "30px", marginTop: "20px" }}
            >
              Property Availability : {propertyFor}
            </div>

            <div className="ap-price-common-grid">
              {!isflag ? (
                <>
                  {" "}
                  <div className="ap-price-row">
                    <label className="ap-price-label">Possession by</label>
                    <div className="ap-price-control">
                      <select
                        className="form-control ap-price-select ap-price-rect-input ap-price-select-half"
                        value={possessionBy}
                        onChange={(event) =>
                          setPossessionBy(event.target.value)
                        }
                        ref={possessionByRef}
                      >
                        <option value="">Select Possession by</option>
                        {lstPossessionBy.map((option) => (
                          <option key={option.TypeId} value={option.TypeId}>
                            {option.TypeName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {renderLimitedChipGroup(
                    "Property on the Floor",
                    lstPropertyOntheFloor.slice(0, 6),
                    propertyOnFloor,
                    setPropertyOnFloor,
                    lstPropertyOntheFloor.slice(
                      6,
                      lstPropertyOntheFloor.length,
                    ),
                    propertyOnFloorRef,
                  )}
                </>
              ) : null}

              {renderLimitedChipGroup(
                "Number of Rooms",
                lstNoofRooms.slice(0, 6),
                numberOfRooms,
                setNumberOfRooms,
                lstNoofRooms.slice(6, lstNoofRooms.length),
                numberOfRoomsRef,
              )}
              {renderLimitedChipGroup(
                "No of Washroom",
                lstNoofWashrooms.slice(0, 6),
                washroomCount,
                setWashroomCount,
                lstNoofWashrooms.slice(6, lstNoofWashrooms.length),
                washroomCountRef,
              )}
              {renderToggleChipGroup({
                label: "Furnishing Status",
                options: lstFurnishStatus,
                value: furnishingStatus,
                setValue: setFurnishingStatus,
                refItem: furnishingStatusRef,
              })}
              {renderFurnishingDetailOptions(furnishingStatus)}

              <div className="ap-price-row">
                <label className="ap-price-label">Facing</label>
                <div className="ap-price-control">
                  <select
                    className="form-control ap-price-select ap-price-select-half"
                    value={facing}
                    onChange={(event) => setFacing(event.target.value)}
                  >
                    <option value="">Select Facing</option>
                    {lstFacing.map((option) => (
                      <option key={option.TypeId} value={option.TypeId}>
                        {option.TypeName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="ap-price-row">
                <label className="ap-price-label">Age of Property</label>
                <div className="ap-price-control">
                  <select
                    className="form-control ap-price-select ap-price-select-half"
                    value={ageOfProperty}
                    onChange={(event) => setAgeOfProperty(event.target.value)}
                  >
                    <option value="">Select Age of Property</option>
                    {lstAgeofProperty.map((option) => (
                      <option key={option.TypeId} value={option.TypeId}>
                        {option.TypeName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {renderToggleChipGroup({
                label: "Ownership Status",
                options: lstOwnershipStatus,
                value: ownershipStatus,
                setValue: setOwnershipStatus,
                refItem: ownershipStatusRef,
              })}
              {propertyFor === "Rent" &&
                renderToggleChipGroup({
                  label: "Available For",
                  options: lstAvailableforRent,
                  value: availableForRent,
                  setValue: setAvailableForRent,
                  refItem: availableForRentRef,
                })}
              {renderToggleChipGroup({
                label: "Parking",
                options: lstParking,
                value: parking,
                setValue: setParking,
                refItem: parkingRef,
              })}
            </div>

            <div className="box-btn ap-price-actions">
              <button
                type="submit"
                className="tf-btn primary"
                onClick={() => ValidateSubmit()}
              >
                {edit ? "Update" : "Save"}{" "}
                <i className="icon icon-arrow-right" />
              </button>
            </div>
          </div>
        </div>

        {/* <AddPropertyPriceSection
          param_propertyFor={propertyFor}
          lstUnitArea={lstUnitArea}
          lstPossessionBy={lstPossessionBy}
          lstPropertyOntheFloor={lstPropertyOntheFloor}
          lstNoofRooms={lstNoofRooms}
          lstNoofWashrooms={lstNoofWashrooms}
          lstFurnishStatus={lstFurnishStatus}
          lstFacing={lstFacing}
          lstAgeofProperty={lstAgeofProperty}
          lstOwnershipStatus={lstOwnershipStatus}
          lstAvailableforRent={lstAvailableforRent}
          lstPGAvailablefor={lstPGAvailablefor}
          lstPGRulesAllowed={lstPGRulesAllowed}
          lstPGRulesNotAllowed={lstPGRulesNotAllowed}
          lstParking={lstParking}
        /> */}
      </div>

      <div className="widget-box-2 wd-listing">
        <h5 className="title">My Properties</h5>
        <input
          type="text"
          className="form-control mb-20"
          placeholder="Search by Property ID, Title, Description, Type, Category, Status"
          value={SearchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
        />

        <div className="wrap-table ap2-properties-table-wrap">
          <div className="table-responsive ap2-properties-table-scroll">
            <table className="ap2-properties-table">
              <thead>
                <tr>
                  <th style={{ width: "2%" }}>Sr No</th>
                  <th style={{ width: "15%" }}>Action</th>
                  <th style={{ width: "45%" }}>Property Title & Detail</th>
                  <th style={{ width: "10%" }}>Property Images</th>
                  <th style={{ width: "10%" }}>Inside Facilities</th>
                  <th style={{ width: "10%" }}>Outer Facilities</th>
                  <th style={{ width: "10%" }}>Property Document</th>
                  <th style={{ width: "10%" }}>Property Floor</th>
                </tr>
              </thead>
              <tbody>
                {(Array.isArray(myPropertiesFilter) ? myPropertiesFilter : [])
                  .slice((page - 1) * ItemsPerPage, page * ItemsPerPage)
                  .map((propertyItem, index) => (
                    <tr className="file-delete" key={index}>
                      <td>
                        <span>{(page - 1) * ItemsPerPage + index + 1}</span>
                      </td>
                      <td>
                        {!isClosedPropertyStatus(propertyItem.PropertyFor) ? (
                          <div style={{ marginBottom: "10px" }}>
                            {propertyItem.IsFeatured ? (
                              <a
                                className="remove-file item btn btn-sm btn-primary"
                                disabled="true"
                                style={{ cursor: "not-allowed" }}
                              >
                                Featured Property
                              </a>
                            ) : propertyItem.IsWantFeatureProperty &&
                              propertyItem.IsFeatured ? (
                              <a
                                className="remove-file item btn btn-sm btn-success"
                                disabled="true"
                                style={{ cursor: "not-allowed" }}
                              >
                                Featured
                              </a>
                            ) : !propertyItem.IsWantFeatureProperty ? (
                              <a
                                className="remove-file item btn btn-sm btn-warning"
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "You can contact team AskMeReality to make your property featured. Do you want to send request now?",
                                    )
                                  ) {
                                    HandleRequestPropertyfeature(
                                      propertyItem.PropertyId,
                                    );
                                  }
                                }}
                              >
                                Make Feature
                              </a>
                            ) : propertyItem.IsWantFeatureProperty &&
                              !propertyItem.IsFeatured ? (
                              <a
                                className="remove-file item btn btn-sm btn-success"
                                disabled="true"
                                style={{ cursor: "not-allowed" }}
                              >
                                Request Sent
                              </a>
                            ) : null}
                          </div>
                        ) : (
                          <>
                            <div className="ap2-property-marked-badge">
                              Property Marked : {propertyItem.PropertyFor}
                            </div>
                          </>
                        )}
                        <div style={{ marginBottom: "10px" }}>
                          {propertyItem.PropertyFor == "Rent" ||
                          propertyItem.PropertyFor == "Sell" ||
                          propertyItem.PropertyFor == "PG" ? (
                            !isClosedPropertyStatus(propertyItem.PropertyFor) &&
                            String(propertyItem.PropertyFor ?? "")
                              .trim()
                              .toLowerCase() ==
                              String(propertyItem.PropertyFor ?? "")
                                .trim()
                                .toLowerCase() ? (
                              <button
                                type="button"
                                className="btn btn-sm btn-warning"
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      `Are you sure you want to mark this property as ${getClosedPropertyStatus(propertyItem.PropertyFor)}?`,
                                    )
                                  ) {
                                    fnUpdatePropertyStatus(propertyItem);
                                  }
                                }}
                              >
                                Mark as{" "}
                                {getClosedPropertyStatus(
                                  propertyItem.PropertyFor,
                                )}
                              </button>
                            ) : null
                          ) : null}
                        </div>
                        {!isClosedPropertyStatus(propertyItem.PropertyFor) ? (
                          <ul className="list-action ">
                            <li>
                              <a
                                className=" btn btn-sm btn-primary"
                                onClick={() =>
                                  fnEditPropertyDetails(propertyItem.PropertyId)
                                }
                              >
                                Edit
                              </a>
                            </li>

                            <li>
                              <a
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure you want to delete this property? This will permanently remove all related details, including photos, documents, amenities, floor plans.",
                                    )
                                  ) {
                                    fnDeleteProperty(propertyItem.PropertyId);
                                  }
                                }}
                              >
                                Delete
                              </a>
                            </li>
                          </ul>
                        ) : null}
                      </td>

                      <td>
                        <div className="listing-box">
                          <div className="content">
                            <span
                              style={{
                                fontWeight: "bolder",
                                letterSpacing: "1px",
                              }}
                            >
                              {propertyItem.PropertyGeneratedId}{" "}
                            </span>

                            <div className="title">
                              <Link className="link">
                                {propertyItem.PropertyFor} :{" "}
                                {propertyItem.PropertyTitle}
                              </Link>
                            </div>
                            <span
                              style={{ fontSize: "13px" }}
                            >{`${propertyItem.BuildingTypeName} : ${propertyItem.PropertyTypeName}`}</span>
                            <div className="text-date">
                              Posted Date:{" "}
                              {propertyItem.CreatedOn
                                ? new Date(
                                    propertyItem.CreatedOn,
                                  ).toLocaleDateString("en-US", {
                                    month: "long",
                                    day: "numeric",
                                    year: "numeric",
                                  })
                                : ""}
                            </div>
                            <span
                              style={{
                                fontWeight: "bolder",
                                letterSpacing: "1px",
                              }}
                            >
                              {propertyItem.StatusName}
                            </span>

                            {propertyItem.IsPropertyImages && (
                              <Link
                                to={`/property-details/${propertyItem.AutoGeneratedURL}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="ap2-preview-link-btn"
                              >
                                Link Preview
                              </Link>
                            )}
                          </div>
                        </div>
                      </td>
                      <td>
                        <button
                          type="button"
                          onClick={() =>
                            window.open(
                              `/add-photos?id=${propertyItem.PropertyId}`,
                              "_blank",
                              "noopener,noreferrer",
                            )
                          }
                          className={`ap2-table-action-btn ${propertyItem.IsPropertyImages ? "is-available" : "is-missing"}`}
                        >
                          <span className="ap2-table-action-btn__icon">
                            <i className="fa-solid fa-image" />
                          </span>
                          <span>
                            {propertyItem.IsPropertyImages
                              ? "Update Images"
                              : "Add Images"}
                          </span>
                          <i className="icon icon-arrow-right ap2-table-action-btn__arrow" />
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          onClick={() =>
                            window.open(
                              `/add-amenities?id=${propertyItem.PropertyId}`,
                              "_blank",
                              "noopener,noreferrer",
                            )
                          }
                          className={`ap2-table-action-btn ${propertyItem.IsPropertyAmenities ? "is-available" : "is-missing"}`}
                        >
                          <span className="ap2-table-action-btn__icon">
                            <i className="fa-solid fa-home" />
                          </span>
                          <span>
                            {propertyItem.IsPropertyAmenities
                              ? "Update Inside Facilities"
                              : "Add Inside Facilities"}
                          </span>
                          <i className="icon icon-arrow-right ap2-table-action-btn__arrow" />
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          onClick={() =>
                            window.open(
                              `/add-near-amenities?id=${propertyItem.PropertyId}`,
                              "_blank",
                              "noopener,noreferrer",
                            )
                          }
                          className={`ap2-table-action-btn ${propertyItem.IsPropertyNearAmenities ? "is-available" : "is-missing"}`}
                        >
                          <span className="ap2-table-action-btn__icon">
                            <i className="fa-solid fa-building" />
                          </span>
                          <span>
                            {propertyItem.IsPropertyNearAmenities
                              ? "Update Near Facilities"
                              : "Add Near Facilities"}
                          </span>
                          <i className="icon icon-arrow-right ap2-table-action-btn__arrow" />
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          onClick={() =>
                            window.open(
                              `/add-document?id=${propertyItem.PropertyId}`,
                              "_blank",
                              "noopener,noreferrer",
                            )
                          }
                          className={`ap2-table-action-btn ${propertyItem.IsPropertyDocument ? "is-available" : "is-missing"}`}
                        >
                          <span className="ap2-table-action-btn__icon">
                            <i className="fa-solid fa-file" />
                          </span>
                          <span>
                            {propertyItem.IsPropertyDocument
                              ? "Update Document"
                              : "Add Document"}
                          </span>
                          <i className="icon icon-arrow-right ap2-table-action-btn__arrow" />
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          onClick={() =>
                            window.open(
                              `/add-floor-plan?id=${propertyItem.PropertyId}`,
                              "_blank",
                              "noopener,noreferrer",
                            )
                          }
                          className={`ap2-table-action-btn ${propertyItem.IsPropertyFloor ? "is-available" : "is-missing"}`}
                        >
                          <span className="ap2-table-action-btn__icon">
                            <i className="fa-solid fa-columns" />
                          </span>
                          <span>
                            {propertyItem.IsPropertyFloor
                              ? "Update Floor Plan"
                              : "Add Floor Plan"}
                          </span>
                          <i className="icon icon-arrow-right ap2-table-action-btn__arrow" />
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ul className="wd-navigation">
            <Pagination2
              itemLength={myPropertiesFilter.length}
              itemPerPage={ItemsPerPage}
              setPage={setPage}
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default AddProperty2;
